import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Address, Rider, RiderProfileDetail } from '@uzurv/clara';
import { DateFormatConstants, isNullOrUndefined } from '@uzurv/core';
import moment from 'moment';

@Component({
  selector: 'app-uzurv-rider-profile',
  templateUrl: './uzurv-rider-profile.component.html',
  styleUrls: ['./uzurv-rider-profile.component.scss']
})
export class UzurvRiderProfileComponent implements OnInit, OnChanges {
  @Input() rider: Rider;

  @Input() riderProfileDetail: RiderProfileDetail;

  @Input() riderAddress: Address;

  @Input() isOrganizationRiderAppEnabled: boolean;

  @Input() isSendingUzurvRideAppInvitation: boolean;

  @Output() editRiderButtonClicked = new EventEmitter<void>();

  @Output() sendUzurvRideAppInvitation = new EventEmitter<void>();

  riderOver18: boolean;

  riderAge: number;

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rider']) {
      this.riderOver18 = this.isRiderOver18();
    }
  }

  ngOnInit(): void {}

  getFormattedDateOfBirth(dateOfBirth: Date): string {
    if (isNullOrUndefined(dateOfBirth)) {
      return null;
    }

    return moment(dateOfBirth).format(DateFormatConstants.DATE_OF_BIRTH);
  }

  isRiderOver18(): boolean {
    const today = new Date();
    const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

    if (!isNullOrUndefined(this.rider.dateOfBirth)) {
      this.riderAge = moment().diff(this.rider.dateOfBirth, 'years');
    }
    const birthDate = new Date(this.rider.dateOfBirth);

    return birthDate <= eighteenYearsAgo;
  }

  handleEditRiderButtonClicked() {
    this.editRiderButtonClicked.emit();
  }

  handleSendUzurvRideAppInvitation() {
    this.sendUzurvRideAppInvitation.emit();
  }
}
